import { FirstSectionContainer } from './styles'

import logoQuadra from '../../../../assets/logos/logo-quadra.svg'

export function FirstSection() {
  return (
    <FirstSectionContainer>
      <div className="first-section-content-container">
        <img src={logoQuadra} />
        <div className="infos-container">
          {/*   <h1>+Quadra</h1>
          <div className='address-container'>
            <div className="individual-info-container">
              <h2>QUADRA STORE</h2>
              <span>PE. Eutíquio, 1612, Batista Campos</span>
            </div>
            <div className="individual-info-container">
              <h2>STAND BRÁS</h2>
              <span>Brás de Aguar, 580, Nazaré</span>
            </div>
          </div> */}
        </div>
      </div>
    </FirstSectionContainer>
  )
}

